import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "replace",
  standalone: false
})
export class ReplacePipe implements PipeTransform {
  transform(value: string, searchValue: string, replaceValue: string): string {
    return value.replaceAll(searchValue, replaceValue);
  }
}
